import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { PageNotFoundComponent } from "./screens/page-not-found/page-not-found.component";
import { PrestationComponent } from "./screens/prestation/prestation.component";
import { RegisterComponent } from "./screens/register/register.component";
import { InviteFriendComponent } from "./screens/invite-friend/invite-friend.component";
import { UnsubscribeComponent } from "./screens/unsubscribe/unsubscribe.component";
import { LegalnoticesComponent } from "./screens/legalnotices/legalnotices.component";
import { EventComponent } from "./screens/register-event/view/event/event.component"
import { SearchComponent } from "./screens/search/search.component";
import { FormVoluntaryComponent } from "./screens/form-voluntary/form-voluntary.component";

const routes: Routes = [
  { path: '', 
    redirectTo: '/ateliersnumeriques', 
    pathMatch: 'full' 
  },
  {
    path: "voluntary",
    component: FormVoluntaryComponent
  },
  {
    path: "notices",
    component: LegalnoticesComponent
  },
  {
    path: "unsubscribe/:idSlot",
    component: UnsubscribeComponent
  },
  {
    path: ":bu",
    component: PrestationComponent,
  },
  {
    path: ":bu/search",
    pathMatch: 'full',
    component: SearchComponent
  },
  {
    path: ":bu/:event",
    component: EventComponent
  },
  {
    path: ":bu/:event/register",
    component: RegisterComponent
  },
  {
    path: ":bu/:event/invite-friend",
    component: InviteFriendComponent
  },
  {
    path: ":bu/:event/:regionSlug",
    component: EventComponent
  },
  {
    path: ":bu/:event/:regionSlug/:villeSlug",
    component: EventComponent
  },
  {
    path: ":bu/:event/:regionSlug/:villeSlug/:lieuSlug",
    component: EventComponent
  },
  {
    path: "**",
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts